/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  StaticPagePlugin,
  IStaticPagePluginMethods,
  SignInPlugin,
  ISignInPluginMethods,
  URLPlugin,
  IURLPluginMethods,
} from './plugins';

export type TAgent = IStaticPagePluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  ISignInPluginMethods &
  IURLPluginMethods;

const getPlugins = () => {
  return [
    new StaticPagePlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    //Business logic plugins !
    new SignInPlugin(),
    new URLPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
